import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::store
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:24
* @route '/bookings/{booking}/incidentals'
*/
export const store = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/incidentals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::store
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:24
* @route '/bookings/{booking}/incidentals'
*/
store.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return store.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::store
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:24
* @route '/bookings/{booking}/incidentals'
*/
store.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::store
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:24
* @route '/bookings/{booking}/incidentals'
*/
const storeForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::store
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:24
* @route '/bookings/{booking}/incidentals'
*/
storeForm.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::destroy
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:63
* @route '/bookings/{booking}/incidentals/{bookingCharge}'
*/
export const destroy = (args: { booking: string | { id: string }, bookingCharge: string | { id: string } } | [booking: string | { id: string }, bookingCharge: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/bookings/{booking}/incidentals/{bookingCharge}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::destroy
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:63
* @route '/bookings/{booking}/incidentals/{bookingCharge}'
*/
destroy.url = (args: { booking: string | { id: string }, bookingCharge: string | { id: string } } | [booking: string | { id: string }, bookingCharge: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            bookingCharge: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
        bookingCharge: typeof args.bookingCharge === 'object'
        ? args.bookingCharge.id
        : args.bookingCharge,
    }

    return destroy.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{bookingCharge}', parsedArgs.bookingCharge.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::destroy
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:63
* @route '/bookings/{booking}/incidentals/{bookingCharge}'
*/
destroy.delete = (args: { booking: string | { id: string }, bookingCharge: string | { id: string } } | [booking: string | { id: string }, bookingCharge: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::destroy
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:63
* @route '/bookings/{booking}/incidentals/{bookingCharge}'
*/
const destroyForm = (args: { booking: string | { id: string }, bookingCharge: string | { id: string } } | [booking: string | { id: string }, bookingCharge: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\IncidentalsController::destroy
* @see app/Http/Controllers/Admin/Bookings/IncidentalsController.php:63
* @route '/bookings/{booking}/incidentals/{bookingCharge}'
*/
destroyForm.delete = (args: { booking: string | { id: string }, bookingCharge: string | { id: string } } | [booking: string | { id: string }, bookingCharge: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const incidentals = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default incidentals